const Tags = [
  {
    id: 1,
    ca: 'javascript',
    es: 'javascript',
    en: 'javascript',
    priority: 9,
    slug: 'javascript',
  },
  {
    id: 2,
    ca: 'react',
    es: 'react',
    en: 'react',
    priority: 9,
    slug: 'react',
  },
  {
    id: 3,
    ca: 'hooks',
    es: 'hooks',
    en: 'hooks',
    priority: 9,
    slug: 'hooks',
  },
  {
    id: 4,
    ca: 'bootstrap',
    es: 'bootstrap',
    en: 'bootstrap',
    priority: 9,
    slug: 'bootstrap',
  },
  {
    id: 5,
    ca: 'html',
    es: 'html',
    en: 'html',
    priority: 9,
    slug: 'html',
  },
  {
    id: 6,
    ca: 'css',
    es: 'css',
    en: 'css',
    priority: 9,
    slug: 'css',
  },
  {
    id: 7,
    ca: 'tinymce',
    es: 'tinymce',
    en: 'tinymce',
    priority: 9,
    slug: 'tinymce',
  },
  {
    id: 8,
    ca: 'centos',
    es: 'centos',
    en: 'centos',
    priority: 9,
    slug: 'centos',
  },
  {
    id: 9,
    ca: 'ubuntu',
    es: 'ubuntu',
    en: 'ubuntu',
    priority: 9,
    slug: 'ubuntu',
  },
  {
    id: 10,
    ca: 'php',
    es: 'php',
    en: 'php',
    priority: 9,
    slug: 'php',
  },
  {
    id: 11,
    ca: 'npm',
    es: 'npm',
    en: 'npm',
    priority: 9,
    slug: 'npm',
  },
  {
    id: 12,
    ca: 'context',
    es: 'context',
    en: 'context',
    priority: 9,
    slug: 'context',
  },
  {
    id: 13,
    ca: 'prismjs',
    es: 'prismjs',
    en: 'prismjs',
    priority: 9,
    slug: 'prismjs',
  },
]

export default Tags
